import React, { Component } from "react";
import "./EditInventoryItem.scss";
import arrowBack from "../../assets/Icons/arrow_back-24px.svg";
import axios from "axios";

const apiURL = `https://instock-api-rbht.onrender.com`;

class EditInventoryItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itemName: "",
      description: "",
      category: "",
      status: "",
      warehouseName: "",
      quantity: "",
      Warehouses: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  // calls fetch data once component is mounted
  componentDidMount() {
    // change tittle of webpage
    document.title = "Inventory Item Edit";
    this.fetchItem();
    this.fetchWarehouses();
  }
  // fetch item data from API and assign it to state
  fetchItem() {
    let id = this.props.match.params.id;
    console.log(this.props);
    axios.get(`${apiURL}/api/v1/inventories/${id}`).then((response) => {
      this.setState({
        itemName: response.data.itemName,
        description: response.data.description,
        category: response.data.category,
        status: response.data.status,
        warehouseName: response.data.warehouseName,
        quantity: response.data.quantity,
      });
      console.log(this.state.name);
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();

    console.log(this.state.status);
    if (this.state.status === "Out of Stock") {
      this.setState({
        quantity: 0,
      });
    }

    const details = {
      itemName: this.state.itemName,
      description: this.state.description,
      category: this.state.category,
      status: this.state.status,
      quantity: this.state.quantity,
      warehouseName: this.state.warehouseName,
    };

    console.log(this.state.quantity);

    // calls isInputValid to make sure all inputs are valid before editing
    // if valid updated data is sent to backend
    if (this.isInputValid()) {
      // get warehouse id from url
      let id = this.props.match.params.id;
      axios
        .put(`https://instock-api-rbht.onrender.com/api/v1/inventories/${id}`, {
          details,
        })
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // redirect them back
    // this.props.history.goBack();
  };

  fetchWarehouses() {
    axios.get(`${apiURL}/api/v1/warehouses`).then((response) => {
      this.setState({
        Warehouses: response.data,
      });
      console.log(this.state.Warehouses);
    });
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleChangeRadio = (e) => {
    this.setState({
      status: e.target.value,
    });
  };

  isInputValid = () => {
    if (!this.state.itemName.trim() || !this.state.description.trim()) {
      return false;
    }
    return true;
  };

  render() {
    return (
      <>
        <div className="backgroud">
          <div className="page-position">
            <section className="editInventory">
              <form
                className="editInventory__form--real"
                onSubmit={this.handleSubmit}
              >
                {/* Header */}
                <div className="editInventory__title-wrapper">
                  <h1 className="editInventory__title">
                    <img
                      className="editInventory__title--icon"
                      src={arrowBack}
                      onClick={this.props.history.goBack}
                      alt="edit icon"
                    />
                    Edit Inventory Item
                  </h1>
                </div>
                <div className="editInventory-wrapper">
                  <div className="editInventory-tablet-wrapper">
                    {/* Item details section*/}
                    <div className="editInventory__details">
                      <h2 className="editInventory__details--header">
                        Item Details
                      </h2>
                      {/* Item details form*/}

                      <div className="editInventory__form">
                        {/*Item Name */}
                        <label className="editInventory__form--label">
                          Item Name
                        </label>
                        <input
                          className="editInventory__form--input"
                          type="text"
                          onChange={this.handleChange}
                          value={this.state.itemName}
                          name="itemName"
                        ></input>
                        {/* Description */}
                        <label className="editInventory__form--label">
                          Description
                        </label>
                        <textarea
                          className="editInventory__form--input description"
                          type="text"
                          onChange={this.handleChange}
                          value={this.state.description}
                          name="description"
                        ></textarea>
                        {/* Category */}
                        <label className="editInventory__form--label">
                          Category
                        </label>
                        <select
                          className="editInventory__form--input"
                          onChange={this.handleChange}
                          value={this.state.category}
                          name="category"
                        >
                          <option value="Electronics">Electronics</option>
                          <option value="Gear">Gear</option>
                          <option value="Apparel">Apparel</option>
                          <option value="Accessories">Accessories</option>
                          <option value="Health">Health</option>
                        </select>
                      </div>
                    </div>
                    {/* Item Availability section*/}
                    <div className="editInventory__availability">
                      <h2 className="editInventory__availability--header">
                        Item Availability
                      </h2>
                      {/* Contact details form*/}
                      <div className="editInventory__form">
                        {/*Status */}
                        <label className="editInventory__form--label">
                          Status
                          <div className="editInventory__form--radio-container">
                            <input
                              className="editInventory__form--radioBtn"
                              id="in-stock"
                              type="radio"
                              value="In Stock"
                              checked={this.state.status === "In Stock"}
                              onChange={this.handleChangeRadio}
                              name="status"
                            ></input>
                            <label
                              className="editInventory__form--radio-label"
                              htmlFor="in-stock"
                            >
                              In stock
                            </label>
                            <input
                              className="editInventory__form--radioBtn"
                              type="radio"
                              id="out-of-Stock"
                              value="Out of Stock"
                              checked={this.state.status === "Out of Stock"}
                              onChange={this.handleChangeRadio}
                              name="status"
                            ></input>
                            <label
                              className="editInventory__form--radio-label"
                              htmlFor="out-of-stock"
                            >
                              Out of stock
                            </label>
                          </div>
                        </label>
                        {/*Warehouse*/}
                        <label className="editInventory__form--label">
                          Warehouse
                        </label>
                        <select
                          className="editInventory__form--input"
                          name="warehouseName"
                          onChange={this.handleChange}
                          value={this.state.warehouseName}
                        >
                          {this.state.Warehouses &&
                            this.state.Warehouses.map((warehouse) => {
                              return (
                                <option
                                  value={warehouse.name}
                                  key={warehouse.id}
                                >
                                  {warehouse.name}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="editInventory__button-container">
                    <div className="editInventory__button-wrapper">
                      <button
                        onClick={this.props.history.goBack}
                        className="editInventory__button--cancel"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="editInventory__button--save"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </section>
          </div>
        </div>
      </>
    );
  }
}

export default EditInventoryItem;
